<template>
  <div :class="`form-element-viewer ${type}-viewer`">
    {{ value }}
  </div>
</template>

<script>
export default {
  props: {
    value: { type: [String, Number], default: null },
    type: { type: String, required: true },
    options: { type: Object, required: true }
  }
};
</script>
